import { z } from "zod";

import { eventTypeSchema } from "./event-type-schema";

export const deliveryFailureSchema = z.object({
	code: z.enum([
		"Unknown",
		"HttpError",
		"DeliveryTimeout",
		"RequestCanceled",
		"ConnectionFailed",
		"CircuitOpen",
		"EdgeInvocationFailed",
		"AuthenticationFailed",
		"EdgeDeviceNotRegistered",
		"EdgeDeviceUnavailable",
	]),
	httpStatusCode: z.number().int().min(100).max(599).nullish(),
	get lastFailure() {
		return deliveryFailureSchema.nullish();
	},
});

export type DeliveryFailure = z.infer<typeof deliveryFailureSchema>;

export const failedNotificationSchema = z.object({
	id: z.uuid(),
	createdAt: z.iso.datetime({ offset: true }),
	eventType: eventTypeSchema,
	alias: z.string().nullable(),
	failureReason: deliveryFailureSchema.nullable(),
	payload: z.record(z.string(), z.unknown()),
});

export const failedNotificationPageSchema = z.object({
	total: z.number().int().nonnegative(),
	items: z.array(failedNotificationSchema),
});

export type FailedNotification = z.infer<typeof failedNotificationSchema>;
export type FailedNotificationPage = z.infer<typeof failedNotificationPageSchema>;
